/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  OverlayTrigger,
  FormControl,
  Pagination,
  Tooltip,
  Modal,
  FormGroup,
  ControlLabel,
} from "react-bootstrap";
import {
  deleteInventory,
  GetInventoryList,
  searchSubscriptionPackage,
  searchInvetory,
  uploadbulkinventry,
} from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import { Link, withRouter } from "react-router-dom";
import { style } from "../../../variables/Variables";
import DatePicker from "react-datepicker";
import Datetime from "react-datetime";
import LoadingSpinner from "views/Components/loadingSpinner";
import NotificationSystem from "react-notification-system";
import Card from "components/Card/Card.jsx";
import SweetAlert from "react-bootstrap-sweetalert";

import Button from "components/CustomButton/CustomButton.jsx";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class viewSubscriptionpackage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inventory_detail: [],
      category: [],
      paginationData: [],
      nextpage: "",
      prevpage: "",
      _notificationSystem: null,
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      tabledata: "",
      tier_name: "",
      subscription_fees: "",
      description: "",
      delivery_distance_from: "",
      delivery_distance_to: "",
      title: "",
      description: "",
      batch_no: "",
      size: "",
      brand: "",
      page: "",
      loading: false,
      alert: null,
      useraccess: "",
      noRecordFound: false,
      medication_title: "",
      expiry_date: "",
      showBulkUpload: false,
      selectedFile: [],
      fileError: "",
      fileErrorMessage: [],
      uploadfailalert: null,
    };
    this.selectedinventory = this.selectedinventory.bind(this);
    this.deleteinventory = this.deleteinventory.bind(this);
    this.searchdata = this.searchdata.bind(this);

    this.resetSearch = this.resetSearch.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.onChange = this.onChange.bind(this);
    this.upload = this.upload.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.onDownload = this.onDownload.bind(this);
    this.bulkuploadinv = this.bulkuploadinv.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
  }
  selectedinventory(cus) {
    localStorage.setItem("inventoryId", JSON.stringify(cus));

    this.props.history.push("/admin/editInventory");
  }

  handleSuccess(position, message) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: <div>{message}</div>,
      level: level,
      position: position,
      autoDismiss: 3,
    });

    this.setState({
      showBulkUpload: false,
      selectedFile: [],
      fileError: "",
      // fileErrorMessage:"",
    });
  }
  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {/* <b>Network Error</b>. */}
          <b>{getApiErrorMessage(error)}</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));

    const obj = token.token;
    /*  GetInventoryList(obj)
        .then((response) => {
            console.log(response.data.data.data,"inventry data");
            this.setState({
              inventory_detail: response.data.data.data
          })
           
        })
        */
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    this.setState({
      useraccess: token.role,
    });
    this.searchData();
  }
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  paginationinfo(url) {
    this.setState({ page: url });
    this.searchData();
  }
  searchdata(e) {
    this.setState({ page: "" });
    this.searchData();
  }
  resetSearch(e) {
    this.setState({ expiry_date: "", medication_title: "" });
    this.searchData();
  }
  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
    this.setState({ noRecordFound: false });
    var date = "";
    var today = "";
    date = new Date(this.state.expiry_date);
    var dd = ("0" + date.getDate()).slice(-2);
    var mm = ("0" + (date.getMonth() + 1)).slice(-2);
    var yyyy = date.getFullYear();
    if (dd != "aN") {
      today = yyyy + "-" + mm + "-" + dd;
    } else {
      today = "";
    }

    // console.log(this.state.itemcode,this.state.description,this.state.price,this.state.medicationcategory,this.state.commision,this.state.unitprice,this.state.page)
    this.setState({ loading: true }, () => {
      searchInvetory(
        this.state.medication_title,
        today,
        this.state.page,
        obj,
      ).then((response1) => {
        var data = response1.data;

        // console.log(data.next_page_url);
        // console.log(data,data.last_page);
        if (data.data.length == 0) {
          this.setState({ noRecordFound: true });
        }
        var $no_pages = [];
        let serach_string = "";
        for (var i = 1; i <= data.last_page; i++) {
          if (serach_string == "") {
            $no_pages.push(i);
          } else {
            $no_pages.push(i);
          }
        }

        if (data.current_page == data.last_page) {
          this.setState({ prevdisabled: null });
          this.setState({ nextdisabled: "1" });
        } else if (data.current_page == 1) {
          this.setState({ nextdisabled: null });
          this.setState({ prevdisabled: "1" });
        } else {
          this.setState({ nextdisabled: null });
          this.setState({ prevdisabled: null });
        }
        if (data.last_page == 1) {
          this.setState({ nextdisabled: 1 });
          this.setState({ prevdisabled: 1 });
        }
        if (data.data.length == 0) {
          $no_pages = [];
          this.setState({ nextdisabled: 1 });
          this.setState({ prevdisabled: 1 });
        }
        this.setState({ currentPage: data.current_page });
        if (data.next_page_url != null) {
          if (serach_string == "") {
            this.setState({
              nextpage: data.next_page_url.substring(
                data.next_page_url.indexOf("=") + 1,
              ),
            });
          } else {
            this.setState({
              nextpage: data.next_page_url.substring(
                data.next_page_url.indexOf("=") + 1,
              ),
            });
          }
        } else {
          this.setState({ nextpage: "#" });
        }
        if (data.prev_page_url != null) {
          if (serach_string == "") {
            this.setState({
              prevpage: data.prev_page_url.substring(
                data.prev_page_url.indexOf("?page=") + 1,
              ),
            });
          } else {
            this.setState({
              prevpage: data.prev_page_url.substring(
                data.prev_page_url.indexOf("?page=") + 1,
              ),
            });
          }
        } else {
          this.setState({ prevpage: "#" });
        }

        this.setState({ paginationData: $no_pages });

        this.setState({
          loading: false,
          inventory_detail: data.data,
        });
      });
    });
  }
  warningWithConfirmAndCancelMessage(id) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deleteinventory(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this Inventory Detail !
        </SweetAlert>
      ),
    });
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  deleteinventory(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    deleteInventory(obj, id)
      .then(() => {
        this.setState({
          alert: null,
        });
        this.handleSuccess("bl", "Inventory Deleted Successfully.");
        this.searchData();
      })
      .catch((error) => {
        this.handleNetworkError("bl", error);
      });
  }
  addInventory() {
    this.props.history.push("/admin/inventory");
  }
  handleDateChange = (date) => {
    this.setState({
      expiry_date: date,
    });
  };
  closeCancelModal = () => {
    this.setState({ showBulkUpload: false, selectedFile: [], fileError: "" });
  };

  ConfirmAndCancelMessage(id) {
    this.setState({
      uploadfailalert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Fail!"
          onCancel={() => this.hideAlert()}
          cancelBtnBsStyle="info"
          cancelBtnText="Close"
          showConfirm={false}
          showCancel
        >
          Add inventory items job failed. Please check your file data and try
          again.
        </SweetAlert>
      ),
    });
  }

  hideAlert() {
    this.setState({
      uploadfailalert: null,
      selectedFile: [],
    });
  }

  ConfirmAndUpload() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    if (this.state.selectedFile == []) {
      this.setState({
        fileError: (
          <small className="text-danger">
            Please select inventory item file.
          </small>
        ),
      });
    } else {
      this.setState({
        fileError: "",
        // fileErrorMessage:"",
        isLoading: true,
      });

      const formData = new FormData();
      formData.append("excel_file", this.state.selectedFile);

      uploadbulkinventry(formData, obj)
        .then((res) => {
          console.log(res);
          if (res.data.success === false) {
            this.setState({ isLoading: false });
            this.ConfirmAndCancelMessage();
          } else if (res.data.success === true) {
            this.handleSuccess("bl", "Inventory Items added successfully.");
          }
        })
        .catch((error) => {
          if (error.response.data.message) {
            this.setState({ fileErrorMessage: error.response.data.message });
          }
          console.log("error", this.state.fileErrorMessage);

          this.handleNetworkError("bl", error);
          this.setState({ isLoading: false });
          console.log(error, "== error");
        });
      // console.log(res);
    }
  }

  onDownload = (e) => {
    const link = document.createElement("a");
    link.href =
      "https://admin-api-staging.flash.health/uploads/inventory_excel.xlsx";
    link.target = "_blank";
    // document.body.appendChild(link)
    link.click();
  };

  handleFileChange(event) {
    if (event.target.files.length > 0) {
      if (
        event.target.files[0].name.includes(".xlsx") ||
        event.target.files[0].name.includes(".xlsm") ||
        event.target.files[0].name.includes(".xlsb") ||
        event.target.files[0].name.includes(".xltx") ||
        event.target.files[0].name.includes(".xltm") ||
        event.target.files[0].name.includes(".xls") ||
        event.target.files[0].name.includes(".xlt") ||
        event.target.files[0].name.includes(".xml") ||
        event.target.files[0].name.includes(".xlam") ||
        event.target.files[0].name.includes(".xla") ||
        event.target.files[0].name.includes(".xlw") ||
        event.target.files[0].name.includes(".xlr")
      ) {
        this.setState({
          selectedFile: event.target.files[0],
          fileError: "",
        });
      } else {
        this.setState({
          fileError: <small className="text-danger">Invalid file format</small>,
        });
      }
    }
  }

  upload() {
    document.getElementById("selectLeadExcelFile").click();
    this.setState({
      selectedFile: [],
      fileError: "",
    });
  }

  bulkuploadinv = () => {
    this.setState({
      showBulkUpload: true,
      selectedFile: [],
      fileError: "",
    });
  };

  render() {
    const view = <Tooltip id="view">View Profile</Tooltip>;
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;
    const inventory_details = this.state.inventory_detail;
    const category = this.state.category;

    var c = 1;

    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          {this.state.uploadfailalert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={12}>
              <Card
                tableFullWidth
                content={
                  <Row>
                    <Col md={12} sm={12} lg={12} xs={12}>
                      <Col
                        md={12}
                        sm={12}
                        lg={12}
                        xs={12}
                        className="text-right"
                        style={{ marginBottom: "10px" }}
                      >
                        <Button
                          className="btn-fill "
                          class="btn-color "
                          style={{ marginRight: "10px" }}
                          fill
                          onClick={this.bulkuploadinv.bind(this)}
                        >
                          Upload Bulk Inventory Items
                        </Button>
                        <Button
                          className="btn-fill"
                          class="btn-color "
                          style={{ width: "180px" }}
                          fill
                          onClick={this.addInventory.bind(this)}
                        >
                          Add Inventory<i className="fa fa-plus"></i>
                        </Button>
                      </Col>
                    </Col>
                    <Col md={12} sm={12} lg={12} xs={12}>
                      <Col
                        md={1}
                        sm={1}
                        lg={1}
                        xs={12}
                        className="fl_mb _1"
                        style={{
                          paddingLeft: "18px",
                          width: "18%",
                          position: "relative",
                          right: "6px",
                        }}
                      >
                        <FormControl
                          style={{ textAlign: "center" }}
                          name="medication_title"
                          value={this.state.medication_title || ""}
                          placeholder="Item Name"
                          onChange={this.onChange}
                          type="text"
                        />
                      </Col>
                      <Col md={3} sm={3} lg={3} xs={12} className="fl_mb _1">
                        <Datetime
                          timeFormat={false}
                          dateFormat="YYYY-MM-DD"
                          inputProps={{ placeholder: "Expiry Date" }}
                          // defaultValue={new Date()}
                          closeOnSelect={true}
                          value={this.state.expiry_date}
                          onChange={this.handleDateChange}
                        />
                      </Col>

                      <Col md={3} sm={4} lg={3} xs={12} className="fl_mb_1">
                        <Button
                          class="btn-color" //bsStyle="info"
                          fill
                          onClick={this.searchdata.bind(this)}
                        >
                          Filter
                        </Button>
                        &nbsp;&nbsp;
                        <Button
                          class="btn-color" //bsStyle="info"
                          fill
                          onClick={this.resetSearch.bind(this)}
                        >
                          Reset
                        </Button>
                      </Col>
                    </Col>
                    {/* <Col md={2} style={{width:'160px'}}>
                  <FormControl name="delivery_distance_from" value={this.state.delivery_distance_from ||''} placeholder="Delivery Distance From" onChange={this.onChange} type="text" />
                  </Col> 
                 <Col md={2} style={{width:'160px'}}>
                  <FormControl name="delivery_distance_to" value={this.state.delivery_distance_to ||''} placeholder="Delivery Distance To" onChange={this.onChange} type="text" />
                  </Col> */}
                    <Col md={12} sm={12} lg={12} xs={12}>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Items</th>
                            <th>Goods Recieved</th>
                            <th>Previous Quantity</th>
                            <th>Quantity Added</th>
                            <th>Unit Price</th>
                            <th>Note</th>
                            <th>Expiry Date</th>
                            <th>Added at</th>
                            <th>Batch No</th>
                            <th>Actions</th>
                            {/* <th>size</th>
                        <th className="text-right">Actions</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading ? (
                            <tr>
                              <td col span="10">
                                <LoadingSpinner />
                              </td>
                            </tr>
                          ) : this.state.noRecordFound ? (
                            <tr>
                              <td colspan="10">
                                <center>No record found</center>
                              </td>
                            </tr>
                          ) : (
                            <React.Fragment>
                              {inventory_details.map((cus) => (
                                <tr
                                  key={cus.id}
                                  className={
                                    cus.quantity <= 100 ? "red_background" : ""
                                  }
                                >
                                  <td>{cus.medication.title}</td>
                                  <td>
                                    {cus.is_goods_received == 1
                                      ? " Yes "
                                      : "No"}
                                  </td>
                                  <td>
                                    <p>
                                      {cus.previous_quantity == null ||
                                      cus.previous_quantity == ""
                                        ? "0"
                                        : cus.previous_quantity}
                                    </p>
                                  </td>
                                  <td>
                                    <p>{cus.quantity}</p>
                                  </td>
                                  <td>{cus.unit_price}</td>
                                  <td>{cus.note}</td>
                                  <td>{cus.expiry_date}</td>

                                  <td>{cus.created_at}</td>
                                  <td>{cus.batch_no}</td>
                                  <td className="td-actions text-right">
                                    {/* <OverlayTrigger
                                      placement="top"
                                      overlay={edit}
                                    >
                                      <Button
                                        simple
                                        bsStyle="success"
                                        onClick={this.selectedinventory.bind(
                                          this,
                                          cus.id
                                        )}
                                        bsSize="xs"
                                      >
                                        <Link to="/admin/editInventory">
                                          <i className="fa fa-edit" />
                                        </Link>
                                      </Button>
                                    </OverlayTrigger> */}

                                    {this.state.useraccess == 1 && (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={remove}
                                      >
                                        <Button
                                          simple
                                          bsStyle="danger"
                                          onClick={this.warningWithConfirmAndCancelMessage.bind(
                                            this,
                                            cus.id,
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-times" />
                                        </Button>
                                      </OverlayTrigger>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </React.Fragment>
                          )}
                        </tbody>
                      </Table>
                      {this.state.loading ? (
                        ""
                      ) : this.state.noRecordFound ? (
                        ""
                      ) : (
                        <div style={{ textAlign: "center" }}>
                          <Pagination>
                            <Pagination.First
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.prevpage,
                              )}
                              disabled={this.state.prevdisabled}
                            />
                            {this.state.paginationData.map((url) => (
                              <Pagination.Item
                                active={
                                  this.state.currentPage == c ? "1" : null
                                }
                                onClick={this.paginationinfo.bind(this, url)}
                              >
                                {c++}
                              </Pagination.Item>
                            ))}
                            <Pagination.Last
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.nextpage,
                              )}
                              disabled={this.state.nextdisabled}
                            />
                          </Pagination>
                        </div>
                      )}
                    </Col>
                  </Row>
                }
              />
            </Col>
          </Row>
        </Grid>

        <Modal
          show={this.state.showBulkUpload}
          onHide={() => this.setState({ showBulkUpload: false })}
        >
          <Modal.Header>
            <Modal.Title className="text-center">
              Upload Bulk Inventory Items
              {/* test */}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <FormGroup style={{ marginBottom: "3px" }}>
                <ControlLabel style={{ display: "block" }}>
                  Upload Excel
                </ControlLabel>
                <input
                  style={{ display: "none" }}
                  id="selectLeadExcelFile"
                  type="file"
                  // value={x.selectedFile}
                  className="form-control"
                  multiple
                  name="selectedFile"
                  onChange={this.handleFileChange}
                />
                <Button onClick={this.upload} style={{ color: "#2B3A41" }}>
                  {" "}
                  <i
                    className={
                      this.state.selectedFile.length == 0
                        ? "fa fa-plus"
                        : "fa fa-pencil fa-fw"
                    }
                  ></i>{" "}
                  {this.state.selectedFile.length == 0
                    ? "Choose File"
                    : "Change File"}
                </Button>
                <div style={{ display: "initial", marginLeft: "15px" }}>
                  <Button
                    class="btn-color"
                    onClick={this.onDownload.bind(this)}
                    fill
                  >
                    Download Sample Excel
                  </Button>
                </div>
                <div style={{ marginTop: "10px" }}>
                  {this.state.selectedFile != []
                    ? this.state.selectedFile.name
                    : ""}
                </div>
              </FormGroup>
              <p style={{ fontSize: "medium", marginBottom: "5px" }}>
                {this.state.fileError}
              </p>
            </div>
            {this.state.fileErrorMessage.map((record, index) => (
              <p style={{ color: "red" }} key={index}>
                {record}
              </p>
            ))}
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={this.ConfirmAndUpload.bind(this)}
              bsStyle="success"
              fill
            >
              Upload
            </Button>
            &nbsp;
            <Button
              onClick={this.closeCancelModal.bind(this)}
              bsStyle="info"
              fill
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default viewSubscriptionpackage;
